import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { lazyReadOcsSettings } from 'owa-ocs-service-gql';
import { isValidPersonaCheckboxDisplayOption } from '../store/schema/PersonaCheckboxDisplayOption';

export default async function getPersonaCheckboxDisplayOCSSetting(): Promise<number | null> {
    const personaCheckboxDisplay = await lazyReadOcsSettings.importAndExecute(
        getGlobalSettingsAccountMailboxInfo(),
        'ACCOUNT',
        ['mail_personacheckboxdisplay']
    );

    if (!personaCheckboxDisplay?.[0]) {
        return null;
    }

    try {
        const parsedValue = JSON.parse(personaCheckboxDisplay[0].value);
        return isValidPersonaCheckboxDisplayOption(parsedValue) ? parsedValue : null;
    } catch {
        return null;
    }
}
